module.exports = __webpack_public_path__ + "img/BORNEO-INDOBARA.0c25322d.jpg";